import { AVATAR_PARTS } from './avatarParts';
import { AvatarStyleConfig } from './types';

export const AVATAR_STYLE_CONFIG: AvatarStyleConfig = {
  parts: AVATAR_PARTS,
  baseStyle: {
    container: {
      display: 'flex',
      position: 'relative',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 'full',
      backgroundColor: 'feature.placeholder',
      color: 'feature.onInteraction',
    },
    label: {
      fontWeight: 'heavy',
      cursor: 'default',
      userSelect: 'none',
      whiteSpace: 'nowrap',
    },
    badge: {
      position: 'absolute',
      right: 0,
      bottom: 0,
      transform: 'translate(25%, 25%)',
    },
  },
  sizes: {
    xs: {
      container: {
        boxSize: 2.5,
        '> svg': {
          boxSize: 2,
        },
      },
      label: {
        fontSize: '10px',
        lineHeight: 'sm',
      },
    },
    sm: {
      container: {
        boxSize: 3,
        '> svg': {
          boxSize: 2.5,
        },
      },
      label: {
        fontSize: 'sm',
        lineHeight: 'sm',
      },
    },
    md: {
      container: {
        boxSize: 4,
        '> svg': {
          boxSize: 3,
        },
      },
      label: {
        fontSize: 'md',
        lineHeight: 'md',
      },
    },
    lg: {
      container: {
        boxSize: 5,
        '> svg': {
          boxSize: 4,
        },
      },
      label: {
        fontSize: 'lg',
        lineHeight: 'lg',
      },
    },
  },
  defaultProps: {
    size: 'md',
  },
};
